import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { Trash2, Pencil, Check, X } from "lucide-react";

export default function SettingsTemplates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const load = () => {
    setLoading(true);
    api.get("/mapping-templates").then((r) => setItems(r.data || [])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const startEdit = (t) => { setEditId(t.id); setEditName(t.name); };
  const saveEdit = async (t) => {
    if (!editName.trim()) return;
    try {
      await api.patch(`/mapping-templates/${t.id}`, { name: editName.trim() });
      toast.success("Renamed."); setEditId(null); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Rename failed"); }
  };
  const del = async (t) => {
    if (!window.confirm(`Delete template "${t.name}"?`)) return;
    try { await api.delete(`/mapping-templates/${t.id}`); toast.success("Deleted."); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Delete failed"); }
  };

  return (
    <DashboardLayout>
      <h1 className="text-2xl sm:text-3xl font-bold" data-testid="templates-heading">Mapping templates</h1>
      <p className="mt-1 text-sm text-[#3B424B]">Templates auto-apply on future uploads whose columns match. Renaming or deleting here takes effect immediately.</p>

      {loading ? <div className="mt-6 text-sm text-[#3B424B]">Loading…</div> : items.length === 0 ? (
        <div className="mt-6 tm-card p-8 bg-white" data-testid="templates-empty"><div className="font-semibold">No saved templates yet.</div><p className="mt-2 text-sm text-[#3B424B]">When you apply a column mapping during upload, tick "Save this mapping as a template" to keep it here.</p></div>
      ) : (
        <div className="mt-6 tm-card bg-white overflow-hidden">
          <div className="overflow-x-auto tm-scroll">
            <table className="w-full text-sm">
              <thead className="bg-[var(--tm-off)] text-left text-xs uppercase tracking-wider text-[#3B424B]">
                <tr><th className="p-3">Name</th><th className="p-3">Kind</th><th className="p-3">Columns mapped</th><th className="p-3">Source headers</th><th className="p-3">Created</th><th className="p-3 text-right">Actions</th></tr>
              </thead>
              <tbody>
                {items.map((t) => (
                  <tr key={t.id} className="border-t border-[var(--tm-border)]" data-testid={`template-row-${t.id}`}>
                    <td className="p-3 font-semibold">
                      {editId === t.id ? (
                        <div className="flex gap-2 items-center">
                          <input className="tm-input h-9 max-w-xs" value={editName} onChange={(e) => setEditName(e.target.value)} data-testid={`template-name-${t.id}`} />
                          <button className="tm-btn-primary h-9 px-3" onClick={() => saveEdit(t)} data-testid={`template-save-${t.id}`}><Check size={14} /></button>
                          <button className="tm-btn-outline h-9 px-3" onClick={() => setEditId(null)} data-testid={`template-cancel-${t.id}`}><X size={14} /></button>
                        </div>
                      ) : t.name}
                    </td>
                    <td className="p-3 capitalize">{t.kind}</td>
                    <td className="p-3 font-mono text-xs">{Object.keys(t.mapping || {}).length}</td>
                    <td className="p-3 font-mono text-xs text-[#3B424B] max-w-xs truncate" title={(t.source_headers || []).join(", ")}>{(t.source_headers || []).slice(0, 5).join(", ")}{(t.source_headers || []).length > 5 ? "…" : ""}</td>
                    <td className="p-3 text-[#3B424B]">{new Date(t.created_at).toLocaleDateString()}</td>
                    <td className="p-3 text-right">
                      {editId !== t.id && (
                        <div className="inline-flex gap-2">
                          <button className="tm-btn-outline h-8 px-2 text-xs" onClick={() => startEdit(t)} data-testid={`template-rename-${t.id}`}><Pencil size={13} /> Rename</button>
                          <button className="tm-btn-outline h-8 px-2 text-xs" onClick={() => del(t)} data-testid={`template-delete-${t.id}`}><Trash2 size={13} /> Delete</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
